import cn from "classnames"

import { TitleStepDeployTab } from "@/pages/DeploymentsPage/components/molecules/DeployTab"
import { DownloadFileButton } from "@/pages/DeploymentsPage/components/molecules/DownloadFileButton"

import styles from "./DownloadStep.module.scss"

import type { DownloadStepComponent } from "."

export const DownloadStep: DownloadStepComponent = (props) => {
  const { files, title, titlePrefix, noError } = props

  return (
    <div className={cn(styles.flex, styles.container)}>
      <TitleStepDeployTab prefix={titlePrefix}>{title}</TitleStepDeployTab>
      {noError && (
        <div className={cn(styles.flex, styles.buttons)}>
          {files.map((file) => (
            <DownloadFileButton key={file.name} {...file} />
          ))}
        </div>
      )}
    </div>
  )
}
